import styled from 'styled-components'

import { breakpoints } from '@/config/layout'

const StSourceCard = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  max-height: 200px;
  overflow: hidden;

  ${({ theme }) => `
    gap: ${theme.UI.SpacingPx.Space3};
    padding: ${theme.UI.SpacingPx.Space5};
    background-color: ${theme.Colors.Neutrals.Lightest};
    border-radius: ${theme.UI.BorderRadius.Large}px;
    border: 1px solid ${theme.Components.Card.Border};
  `}

  /* Ensure flex column can shrink */
  > *:first-child {
    min-width: 0;
    flex: 1;
    overflow: hidden;
  }

  /* Title row - ensure icons and badges don't shrink */
  > *:first-child > *:first-child {
    min-width: 0;

    /* Icons and badges should not shrink */
    > svg,
    > img,
    > span[class*='Badge'],
    > *:not(h4) {
      flex-shrink: 0;
    }
  }

  /* Title truncation */
  h4 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    flex: 1;
  }

  /* Description truncation - target the second child (description span) */
  > *:first-child > *:nth-child(2) {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;
  }

  @media ${breakpoints.s} {
    border-width: 2px;
  }
`

export { StSourceCard }
